import User from './index.vue';

const routes = [
  {
    path: '/user',
    name: 'User',
    component: User,
    children: [
      {
        path: 'login',
        name: 'Login',
        meta: {
          layout: 'login'
        },
        component: () =>
          import(/* webpackChunkName: "login" */ './views/NewLogin.vue') //Login
      },
      {
        path: 'auth-token',
        name: 'auth-token',
        meta: {
          layout: 'login'
        },
        component: () =>
          import(/* webpackChunkName: "login" */ './views/NewLoginOtp.vue') //Login
      },
      {
        path: 'mobile',
        name: 'mobile.login',
        meta: {
          layout: 'login'
        },
        component: () =>
          import(/* webpackChunkName: "login" */ './views/Login.vue') //Login
      },
      {
        path: 'loginOtp',
        name: 'LoginOtp',
        meta: {
          layout: 'login'
        },
        component: () =>
          import(/* webpackChunkName: "login-otp" */ './views/LoginOtp.vue')
      },
      {
        path: 'loginSSN',
        name: 'LoginSSN',
        meta: {
          layout: 'login'
        },
        component: () =>
          import(/* webpackChunkName: "login-ssn" */ './views/LoginSSN.vue')
      },
      {
        path: 'loginProgramCode',
        name: 'LoginProgramCode',
        meta: {
          layout: 'login'
        },
        component: () =>
          import(
            /* webpackChunkName: "login-programCode" */ './views/LoginProgramCode.vue'
          )
      },
      {
        path: 'loginSuccess',
        name: 'LoginSuccess',
        meta: {
          layout: 'login'
        },
        component: () =>
          import(
            /* webpackChunkName: "login-success" */ './views/LoginSuccess.vue'
          )
      },
      {
        path: 'pilot-accounts',
        name: 'PilotAccounts',
        meta: {
          layout: 'login'
        },
        component: () =>
          import(
            /* webpackChunkName: "pilot-accounts" */ './views/PilotAccounts.vue'
          )
      },
    ]
  }
];

export default routes;
